// SectionWithCards.tsx
import React from 'react';
import SectionText from './SectionText';
import Card from './Card';
import './SectionWithCards.css';
import { useInView } from 'react-intersection-observer';
import ImageCard from "./ImageCard";

export interface CardsData {
    imagePath?: string;
    icon?: JSX.Element;
    title?: string;
    text?: string;
    color?: string;
}

interface SectionWithCardsProps {
    leftTitle: string;
    leftText: string;
    leftDisclaimer?: string;
    cards: Array<CardsData>;
}

const SectionWithCards: React.FC<SectionWithCardsProps> = ({ leftTitle, leftText, leftDisclaimer, cards }) => {
    const { ref, inView } = useInView({
        triggerOnce: true,
        threshold: 0.5,
    });

    return (
        <div className="section-with-cards" ref={ref}>
            <SectionText title={leftTitle} text={leftText} disclaimer={leftDisclaimer} className={inView ? 'animate-slide-in-left' : ''} />
            <div className="cards-container">
                {cards.map((card, index) => {
                    if (card.imagePath) {
                        return (
                            <ImageCard
                                key={index}
                                imagePath={card.imagePath}
                                className={inView ? 'animate-slide-in-right' : ''}
                            />
                        );
                    }
                    return (
                        <Card
                            key={index}
                            icon={card.icon ? card.icon : <></>}
                            title={card.title ? card.title : ''}
                            text={card.text ? card.text : ''}
                            color={card.color}
                            className={inView ? 'animate-slide-in-right' : ''}
                        />
                    );
                })}
            </div>
        </div>
    );
};


export default SectionWithCards;
